export function haversineKm(a, b) {
  const toRad = (d) => (d * Math.PI) / 180;
  const R = 6371;
  const [lng1, lat1] = a;
  const [lng2, lat2] = b;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

const LAST_CENTER_KEY = "gourmeto.mapCenter.v1";

export function restoLngLat(r) {
  const lat = Number(
    r?.latitude ??
      r?.lat ??
      r?.location?.lat ??
      (Array.isArray(r?.location?.coordinates)
        ? r.location.coordinates[1]
        : undefined),
  );
  const lng = Number(
    r?.longitude ??
      r?.lng ??
      r?.location?.lng ??
      (Array.isArray(r?.location?.coordinates)
        ? r.location.coordinates[0]
        : undefined),
  );
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return [lng, lat];
}

export function readLastMapCenter() {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(LAST_CENTER_KEY));
    if (
      Array.isArray(parsed) &&
      parsed.length === 2 &&
      Number.isFinite(parsed[0]) &&
      Number.isFinite(parsed[1])
    ) {
      return parsed;
    }
  } catch {
    // ignore
  }
  return null;
}

export function writeLastMapCenter(coords) {
  if (
    !Array.isArray(coords) ||
    coords.length !== 2 ||
    !Number.isFinite(coords[0]) ||
    !Number.isFinite(coords[1])
  ) {
    return;
  }
  try {
    sessionStorage.setItem(LAST_CENTER_KEY, JSON.stringify(coords));
  } catch {
    // ignore
  }
}
